import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogActions, DialogContent } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

// import { Logger, LoggerTypes } from '../../../utils'
import { Button, buttonModes, buttonTypes, FormTitle } from '../../../components'

export const UserInfoDialog = ({ setOpenDialog, className }) => {
  const { t } = useTranslation()

  const onCloseDialog = () => setOpenDialog(false)

  // Logger.trace(LoggerTypes.CONTAINER, 'UserInfoDialog.render()', {})

  return (
    <Dialog
      open={true}
      onClose={onCloseDialog} // <-- close while clicking on background
      aria-labelledby="form-dialog-title"
      maxWidth="xl"
      width="xl"
      className={`SimulationDialogLaunch ${className}`}
    >
      <DialogContent>
        <FormTitle title={t('users.info.title')} style={{ fontSize: '20px' }} />
        {/* <section>{t('users.info.explanation')}</section> */}
        <ul>
          <li>Environment: {process.env.NODE_ENV || 'Undefined'}</li>
          <li>Application Name: {process.env.REACT_APP_NAME || 'Undefined'}</li>
          <li>Application ID: {process.env.REACT_APP_AZURE_CLIENT_ID || 'Undefined'}</li>
          <li>Application Authority: {process.env.REACT_APP_AZURE_AUTHORITY || 'Undefined'}</li>
          <li>Application Issuer: {process.env.REACT_APP_AZURE_ISSUER || 'Undefined'}</li>
          <li>SingleRun Report URL: {process.env.REACT_APP_SINGLE_RUN_REPORT_URL || 'Undefined'}</li>
          <li>MultiRun Report URL: {process.env.REACT_APP_MULTI_RUN_REPORT_URL || 'Undefined'}</li>
          <li>Test: {process.env.REACT_APP_TEST || 'Undefined'}</li>
        </ul>
      </DialogContent>
      <DialogActions>
        <Button
          mode={buttonModes.SECONDARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('common.cancel')}
          icon={<CloseIcon />}
          onClick={onCloseDialog}
          className="common_fullwidth"
        />
      </DialogActions>
    </Dialog>
  )
}

UserInfoDialog.displayName = 'UserInfoDialog'

UserInfoDialog.propTypes = {
  setOpenDialog: PropTypes.func.isRequired,
  className: PropTypes.string
}

UserInfoDialog.defaultProps = {
  setOpenDialog: () => {},
  className: ''
}
